// Translation resources for the component namespace. This services all components in the library.
// Any new language needs to have a *.component.json file created with the translations. It also needs to be added to the RESOURCES object.
import EN_COMPONENT from './component/en.component.json'
import ES_COMPONENT from './component/es.component.json'
import FR_COMPONENT from './component/fr.component.json'
import PL_COMPONENT from './component/pl.component.json'
import ZH_COMPONENT from './component/zh.component.json'

export const NS = {
  component: 'component',
} as const

export type TranslationNamespace = keyof typeof NS

export const RESOURCES: Record<
  string,
  Record<TranslationNamespace, Record<string, string>>
> = {
  en: {
    component: EN_COMPONENT,
  },
  es: {
    component: ES_COMPONENT,
  },
  fr: {
    component: FR_COMPONENT,
  },
  pl: {
    component: PL_COMPONENT,
  },
  zh: {
    component: ZH_COMPONENT,
  },
} as const

// Extract the keys from RESOURCES and filter out 'en'
export const LANGUAGES_TO_CHECK = (
  Object.keys(RESOURCES) as Array<keyof typeof RESOURCES>
).filter((lang) => lang !== 'en')
